export default {
    data() {
        return {
            searchResults: [],
            years: [],
            searchedString: '',
            requestedString: '',
            totalCount: 0,
            currentPage: 1,
            isNothingFound: false,
            isLoadMoreClicked: false,
            isLoading: false,
        };
    },
    computed: {
        showLoadMoreButton() {
            return (
                !this.isLoadMoreClicked &&
                this.searchResults.length < this.totalCount
            );
        },
        showMoreButtonText() {
            return `Показать еще ${
                this.totalCount - this.searchResults.length
            }`;
        },
        searchOptions() {
            return this.searchResults.map((item) => item.name);
        },
    },
    mounted() {
        this.setLoading(true);
        this.getData();
    },
    methods: {
        onShowMore() {
            this.isLoadMoreClicked = true;
            this.currentPage = ++this.currentPage;
            this.getData(true);
        },
        getAttachmentTitle(title, type, size) {
            let result = title;

            if (type && type.length) {
                result += ` ${type}`;
            }

            if (size && size.length) {
                result += `, ${size}`;
            }

            return result;
        },
        sortArrayByYearDesc(array) {
            return array.sort((a, b) =>
                Number(a.properties.date) > Number(b.properties.date) ? -1 : 1
            );
        },
        setLoading(isLoading) {
            this.isLoading = isLoading;
        },
        /**
         * @param {Boolean} isAdd — если true, то полученные данные добавляем к текущим, иначе заменяем текущие на полученные
         */
        getData(isAdd = false) {
            this.axios
                .get(this.apiPath)
                .then(({ data }) => {
                    this.isLoadMoreClicked = false;
                    if (data.success) {
                        this.isNothingFound = false;
                        if (isAdd) {
                            this.searchResults = this.sortArrayByYearDesc([
                                ...this.searchResults,
                                ...data.data.list,
                            ]);
                        } else {
                            if (data.data.list) {
                                this.searchResults = this.sortArrayByYearDesc(
                                    data.data.list
                                );
                            } else
                                this.searchResults = [
                                    {
                                        id: null,
                                        name: 'не найдено',
                                        properties: { files: [] },
                                    },
                                ];
                        }
                        if (
                            !this.years.length &&
                            data.data.filters &&
                            data.data.filters.years
                        ) {
                            this.years = data.data.filters.years.sort((a, b) =>
                                Number(a) > Number(b) ? -1 : 1
                            );
                        }
                        this.requestedString = this.searchedString;
                        this.totalCount = data.nav.NavRecordCount;
                    } else {
                        this.isNothingFound = true;
                        this.searchResults = [];
                        this.totalCount = 0;
                    }
                    this.setLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                    this.setLoading(false);
                    this.isNothingFound = true;
                });
        },
        resetPageCount() {
            this.currentPage = 1;
        },
        setSearchedString(value) {
            if (
                value.length ||
                (!value.length && this.isNothingFound) ||
                (!value.length && (this.searchedString || this.requestedString))
            ) {
                this.searchedString = value;
                this.resetPageCount();
                this.setLoading(true);
                this.getData();
            }
        },
    },
};
